import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import * as S from './ChangeApp.styled';
import Hightlighter from 'react-highlight-words';
import { ImageWithFallback } from 'components';
import { appNumberToPromote } from 'store/selectors';

const AppItem = ({
  pba_number,
  image_url,
  pba_name,
  search,
  pba_url1,
  pba_id,
  setChoosedApp,
  choosedApp,
}) => {
  const currentAppNumberToPromote = useSelector(appNumberToPromote);
  const isActive = currentAppNumberToPromote === pba_id || choosedApp === pba_id;

  const handleChooseAppAction = useCallback((data) => {
    setChoosedApp(data);
  }, []);

  return (
    <S.Item key={pba_number} isActive={isActive} onClick={() => handleChooseAppAction(pba_id)}>
      <S.Icon>
        <ImageWithFallback src={`https://cdn.appnext.com/apps/${image_url}`} />
      </S.Icon>
      <S.ItemContent>
        <div style={{ overflow: 'hidden' }}>
          <S.NameRow>
            <Hightlighter
              textToHighlight={`${pba_name}`}
              searchWords={[search]}
              highlightTag='strong'
            />
          </S.NameRow>
          <S.Data>
            <Hightlighter
              textToHighlight={`${pba_url1}`}
              searchWords={[search]}
              highlightTag='strong'
            />
          </S.Data>
        </div>
        <S.AppNumberBox>
          <p>App ID:</p>
          <Hightlighter
            textToHighlight={`${pba_number}`}
            searchWords={[search]}
            highlightTag='strong'
          />
        </S.AppNumberBox>
      </S.ItemContent>
    </S.Item>
  );
};

export default AppItem;
